import React from 'react'
import { Row, Col, Form, FormControl } from 'react-bootstrap'
import { PeopleFill } from 'react-bootstrap-icons'
import useViewport from '../../../hooks/use-viewport'

const CapacityMaximum = ({
    value,
    onChange = () => {}
}) => {
    const { breakpoint, breakpoints } = useViewport()

    return (
        <Form.Group as={Row}>
            <Form.Label column sm={12} md={1} lg={2} xl={6}>
                <PeopleFill size={30} /> {breakpoint >= breakpoints.XL || breakpoint <= breakpoints.SM ? 'Max Capacity' : ''}
            </Form.Label>
            <Col sm={12} md={11} lg={10} xl={6}>
                <FormControl type='number' value={value} onChange={e => onChange(e.target.value)} />
            </Col>
        </Form.Group>
    )
}

export default CapacityMaximum